// Role-based access helpers for WP-B admin pages.
//
// Mirrors docs/saas-plan.md §3.1 RBAC matrix. Server is the source of truth;
// these helpers only drive UI affordances (button disabled state, route
// gating). Mutating endpoints in MSW (and the future real backend) re-check
// the permission and return 403 if abused.

import type { Role } from "@chat-yai/shared";

export const WRITE_ROLES: Role[] = ["owner", "admin"];
export const OWNER_ONLY: Role[] = ["owner"];
export const READ_ALL: Role[] = ["owner", "admin", "viewer", "support"];

export function canManageContent(role: Role | null | undefined): boolean {
  if (!role) return false;
  return role === "owner" || role === "admin";
}

export function canManageBilling(role: Role | null | undefined): boolean {
  return role === "owner";
}

// Support role is meant for read-only conversation / lead triage. They must
// not see workspace settings or BYOK integrations.
export function canViewSettings(role: Role | null | undefined): boolean {
  if (!role) return false;
  return role !== "support";
}

export function canViewIntegrations(role: Role | null | undefined): boolean {
  if (!role) return false;
  return role === "owner" || role === "admin";
}

export function canEditIntegrations(role: Role | null | undefined): boolean {
  return role === "owner";
}

export function permissionTooltip(needed: "write" | "owner" | "non-support"): string {
  switch (needed) {
    case "write":
      return "Requires Admin permission";
    case "owner":
      return "Requires Owner permission";
    case "non-support":
      return "Not available for Support role";
  }
}
